const SceneAlias ={
    wecome: "Welcome",
    taskManager: "taskManager",
    openingAnimation: "openingAnimation",
    mainMenu: "MainMenu",
    simulationScreen: "simulationScreen",
    systemMenu: "systemMenu",
    infoScreen: "InfoScreen",	
}

export default SceneAlias;